import React, { useEffect, useState } from "react";
import Sidebar from "../../comman_page/Sidebar";
import { HeaderDashboard } from "../../comman_page/HeaderDashboard";
import { Container, Row, Col } from "react-bootstrap";
import { DataTable } from "../../../../../sharedComponents/DataTable";
import { Footer } from "../../../../../public/containers/footer/Footer";
import { customer_payment_request, transectionDetail } from "../../../../../Studio-Services/Studio_Services";
import { Link, useLocation } from "react-router-dom";
import { SharedButton } from "../../../../../sharedComponents/Button";
import { AiFillEdit } from "react-icons/ai";
import { DateRange } from "../../../../../sharedComponents/DateRange";
import moment from "moment";
import { finalAMT, taxCalculator } from "../../../../../sharedComponents/MyHelperFunction";

export const IndividualTransactionDetails = () => {
  const location = useLocation();
  const [localdata, setLocaldata] = useState();
  const [totalData, setTotalData] = useState({ 'item': '', 'price': '', 'discount': '', 'tax1': '', 'tax2': '', 'tip': '', 'total': '' });

  useEffect(() => {
    if (location && location.state) {
      let e = location.state;

      let pre = { ...totalData };
      setLocaldata(location.state);

      let tp= 0;

      if (e.tip_comment != '' && !isNaN(parseFloat(e.tip_comment))) { tp = parseFloat(e.tip_comment); }

      let bs = parseFloat(e.amount).toFixed(2);
      let ds = parseFloat(e.discount).toFixed(2);
      let tx1 = taxCalculator(e.amount, e.tax1_rate);
      let tx2 = taxCalculator(e.amount, e.tax2_rate);
      let fnl = finalAMT(e.amount, tx1, tx2);
      let full_final = parseFloat(fnl) + parseFloat(tp);
     

      pre.item = e.item_name; pre.price = bs; pre.discount = ds; pre.tax1 = tx1; pre.tax2 = tx2; pre.tip = tp; pre.total = full_final;
      setTotalData(pre);
    } else setTotalData({ 'item': '', 'price': '', 'discount': '', 'tax1': '', 'tax2': '', 'tip': '', 'total': '' });
  }, [location])


  const refundHandler = () => {

  }

  return (
    <>
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <div className="RightSide">
                <HeaderDashboard />
                <section className="addClient innerContent">
                  <div className="AddClientContent">
                    <Container>
                      <Row>
                        <Col>
                          <h4 className="mb-4 "> Individual Transaction Details </h4>
                        </Col>
                        <Col className="text-right">
                          <SharedButton
                            title={"Back"}
                            onClick={() => { window.history.back(); }}
                            className={"backBtn"}
                            type={"button"}
                          />
                        </Col>
                      </Row>
                      {localdata &&
                        <>
                          <Row>
                            <Col>
                              <div className="DetailsT">
                                <p><b>Date/Time : </b> {moment.unix(localdata.create_dt).format('DD-MMM-YYYY ,hh:mm A')} </p>
                                <p style={{ display: 'flex', marginBottom: '0px' }}> <b>Client : </b> <h5 className="mx-2">{localdata.name + ' ' + localdata.lastname}</h5></p>
                                <p style={{ display: 'flex', marginBottom: '0px' }}> <b>Method : </b> <h5 className="mx-2">{localdata.payment_mode}</h5> </p>
                                {/* <p><b>Card Number :</b> This will be an XXXX card </p> */}
                                <p style={{ display: 'flex', marginBottom: '0px' }}> <b>Trans# : </b> <h5 className="mx-2">{localdata.reference_payment_id} </h5></p>
                                {/* <p> <b>Transaction Performed By :</b> Name of user who completed the transaction </p> */}
                                <p style={{ display: 'flex', marginBottom: '0px' }}> <b>Note : </b> <h5 className="mx-2">{localdata.payment_note}</h5> </p>
                              </div>
                            </Col>
                          </Row>

                          <Row className="mt-3">
                            <Col>
                              <table className="table table-striped">
                                <thead>
                                  <tr>
                                    <th>Item Purchased</th>
                                    <th>Price</th>
                                    <th>Discount</th>
                                    <th>Tax 1</th>
                                    <th>Tax 2</th>
                                    <th>Tip</th>
                                    <th>Total</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>{totalData.item}</td>
                                    <td>$ {parseFloat(totalData.price).toFixed(2)}</td>
                                    <td>$ {parseFloat(totalData.discount).toFixed(2)}</td>
                                    <td>$ {parseFloat(totalData.tax1).toFixed(2)}</td>
                                    <td>$ {parseFloat(totalData.tax2).toFixed(2)}</td>
                                    <td>$ {totalData.tip}</td>
                                    <td>$ {parseFloat(totalData.total).toFixed(2)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex justify-content-end">
                              <button type="button" className="btn btn-success m-1 btshadow" onClick={refundHandler}>Refund/Void</button>
                            </Col>
                          </Row>
                        </>
                      }
                    </Container>
                  </div>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
